<div normal>
    <modal-default-mmaxapp>
        <div class="tarjeta-arrepentimiento">
            <div class="header-modal">
                <div class="titulo">Botón de Arrepentimiento</div>
                <div class="btn-cerrar" (click)="cerrar()">X</div>
            </div>

            <div class="cuerpo-modal" *ngIf="!enviado">
                <p class="instrucciones">
                    Si te arrepentiste de una compra, completa el siguiente formulario para iniciar el proceso de devolución.
                </p>

                <form [formGroup]="formArrepentimiento" (ngSubmit)="enviar()">
                    <div class="campo">
                        <label>Nombre y Apellido *</label>
                        <input type="text" formControlName="nombre" placeholder="Ej: Juan Pérez">
                    </div>

                    <div class="campo">
                        <label>Email de contacto *</label>
                        <input type="email" formControlName="email" placeholder="Ej: juan@mail.com">
                    </div>

                    <div class="campo">
                        <label>Número de Pedido *</label>
                        <input type="text" formControlName="pedido" placeholder="Ej: #12345">
                    </div>

                    <div class="campo">
                        <label>Comentarios adicionales</label>
                        <textarea formControlName="mensaje" rows="3" placeholder="Contanos por qué te arrepentiste (opcional)"></textarea>
                    </div>

                    <div class="info-footer">
                        Los datos serán enviados a <strong>{{mailSoporte}}</strong>
                    </div>

                    <div class="botones">
                        <button type="submit" class="buttonpc" [disabled]="!formArrepentimiento.valid || cargando">
                            {{ cargando ? 'Enviando...' : 'Enviar Solicitud' }}
                        </button>
                    </div>
                </form>
            </div>

            <div class="cuerpo-modal mensaje-exito" *ngIf="enviado">
                <div class="icono-exito">✓</div>
                <h3>¡Solicitud enviada!</h3>
                <p>Tu solicitud de arrepentimiento ha sido recibida satisfactoriamente. Nos pondremos en contacto con vos a la brevedad.</p>
                <div class="botones">
                    <button class="buttonpc whibutton" (click)="cerrar()">Cerrar</button>
                </div>
            </div>
        </div>
    </modal-default-mmaxapp>
</div>
